import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["conditionalSection"]

  connect() {
    this.toggleSections()
  }

  toggleSections() {
    const managementType = this.getSelectedManagementType()

    this.conditionalSectionTargets.forEach(section => {
      if (managementType === "source") { // 2 = source (別ソース)
        section.style.display = "none"
      } else {
        section.style.display = ""
      }
    })
  }

  getSelectedManagementType() {
    const checkedRadio = this.element.querySelector('input[name="useful_materials_management[management_type]"]:checked')
    return checkedRadio ? checkedRadio.value : null
  }
}
